import React, { useEffect, useState } from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../../styles.js"

const ChangesDropdownComponent = props => {
  const { classes } = props;
  
  const [changeDropdownValue, setChange] = useState(props.changeOptions[0]);
  const [toBeReplaced, setReplace] = useState("");

  useEffect(() => {
    props.handleDropdownChange(changeDropdownValue, toBeReplaced)
  }, [changeDropdownValue, toBeReplaced])

  let isReplacement = () => {
    return changeDropdownValue == "Replace current" ? true : false
  }

  let getDropdownInfo = () => {
      return props.selectedValue == "email" ? getEmailInfo() : props.selectedValue == "phone" ? getPhoneInfo() : null
  }

  let getPhoneInfo = () => {
      let phoneArray = []
      props.userInfo.phoneNumbers.map((item) => phoneArray.push(item.phoneno))
      return phoneArray
  }

  let getEmailInfo = () => {
      let emailArray = []
      props.userInfo.emailAddresses.map((item) => emailArray.push(item.email))
      return emailArray
  }

  return (
    <div>
      <GridContainer
          className={classes.containerLine}
      >
          <GridItem xs={6}>
              <FormLabel className={classes.labelHorizontal}>
                  Please specify change
              </FormLabel>
          </GridItem>
          <GridItem xs={6}>
              <Select
                  className={classes.select}
                  onChange={(event) => {
                          setChange(event.target.value)
                          setReplace("")
                          document.getElementById("txtId" + props.iteration).value = ""
                      }}
                  defaultValue={props.changeOptions[0]}
              >
                  {props.changeOptions.map((element, key) => {
                      if (Array.isArray(element)) {
                          return (
                          <MenuItem
                              key={key}
                              classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                              }}
                              value={element[0]}
                          >
                              {element[1]}
                          </MenuItem>
                          );
                      } else {
                          return (
                          <MenuItem
                              key={key}
                              classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                              }}
                              value={element}
                          >
                              {element}
                          </MenuItem>
                          );
                      }
                  })}
              </Select>
          </GridItem>
      </GridContainer>
      {isReplacement()? <GridContainer
          className={classes.containerLine}
      >
          <GridItem xs={6}>
              <FormLabel className={classes.labelHorizontal}>
                  Select value to be replaced
              </FormLabel>
          </GridItem>
          <GridItem xs={6}>
              <Select
                  className={classes.select}
                  onChange={(event) => {
                          setReplace(event.target.value)
                          document.getElementById("txtId" + props.iteration).value = ""
                      }}
                  defaultValue={props.selectDefaultValue}
              >
                  {getDropdownInfo().map((element, key) => {
                      if (Array.isArray(element)) {
                          return (
                          <MenuItem
                              key={key}
                              classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                              }}
                              value={element[0]}
                          >
                              {element[1]}
                          </MenuItem>
                          );
                      } else {
                          return (
                          <MenuItem
                              key={key}
                              classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                              }}
                              value={element}
                          >
                              {element}
                          </MenuItem>
                          );
                      }
                  })}
              </Select>
              {props.replaceError ? "Value cannot be null" : ""}
          </GridItem>
      </GridContainer> : null}
    </div>
  );
};

export default withStyles(styles)(ChangesDropdownComponent);
